import axiosHttp from "./interceptor.service";

// Create or Update user permissions
export const createOrUpdateUserPermission = async (userId, permissions, userModel = "users") => {
  return await axiosHttp.post(`/lmt/userPermission/${userId}`, { permissions, userModel });
};

// Get user permissions by userId
export const getUserPermissions = async (userId) => {
  return await axiosHttp.get(`/lmt/userPermission/${userId}`);
};

// Get all user permissions
export const getAllUserPermissions = async (params = {}) => {
  return await axiosHttp.get("/lmt/userPermissions", { params });
};

// Delete user permissions
export const deleteUserPermission = async (userId) => {
  return await axiosHttp.delete(`/lmt/userPermission/${userId}`);
};

// Reset user permissions
export const resetUserPermissions = async (userId) => {
  return await axiosHttp.put(`/lmt/userPermission/reset/${userId}`);
};

// Get available modules
export const getAvailableModules = async () => {
  return await axiosHttp.get("/lmt/availableModules");
};
